import { extractData } from '@/models';
import type { CryptoCurrency, FiatCurrency, Flow, RelationDetails, RelationLink, SwapRelation, UserType } from '@/types';

import client from '../../assets/js/services/api';

type FiatCurrencyResponse = {
    data: FiatCurrency[]
};
type CryptoCurrencyResponse = {
    data: CryptoCurrency[]
};

declare let PROCESSING_API_URL: string;
const getApiUrl = () => `${PROCESSING_API_URL}/public/processing/v1`;
export default {
    fromFiatCurrencies(flow: Flow, userType?: UserType) {
        return client
            .get<FiatCurrencyResponse>(`${ getApiUrl() }/exchange-form/currency/from/fiat`, { params: { flow, userType } })
            .then(extractData)
            .then(({ data }) => data);
    },

    fromCryptoCurrencies(flow: Flow, userType?: UserType) {
        return client
            .get<CryptoCurrencyResponse>(`${ getApiUrl() }/exchange-form/currency/from/crypto`, { params: { flow, userType } })
            .then(extractData)
            .then(({ data }) => data);
    },

    toFiatCurrencies(flow: Flow, userType?: UserType) {
        return client
            .get<FiatCurrencyResponse>(`${ getApiUrl() }/exchange-form/currency/to/fiat`, { params: { flow, userType } })
            .then(extractData)
            .then(({ data }) => data);
    },

    toCryptoCurrencies(flow: Flow, userType?: UserType) {
        return client
            .get<CryptoCurrencyResponse>(`${ getApiUrl() }/exchange-form/currency/to/crypto`, { params: { flow, userType } })
            .then(extractData)
            .then(({ data }) => data);
    },

    relationDetails(relationLink: RelationLink) {
        return client
            .get<RelationDetails>('/money-service/relation-details/', { params: { link: relationLink } })
            .then(extractData);
    },

    swapRelations() {
        return client
            .get<{data: SwapRelation[] }>(`${ getApiUrl() }/swap-relations/`)
            .then(extractData)
            .then(({ data }) => data);
    },
};
